import React from "react";
import { Handle, Position } from "react-flow-renderer";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { PlayArrow } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 180,
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
    border: "2px solid #667eea",
    color: "white",
    position: "relative",
    transition: "all 0.2s ease",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 6px 16px rgba(102, 126, 234, 0.5)",
    },
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeDescription: {
    fontSize: 11,
    opacity: 0.9,
    marginTop: theme.spacing(0.5),
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #667eea",
    borderRadius: "50%",
  },
}));

const StartNode = ({ data, selected }) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        boxShadow: selected
          ? "0 6px 20px rgba(102, 126, 234, 0.6)"
          : "0 4px 12px rgba(102, 126, 234, 0.4)",
      }}
    >
      <Handle
        type="source"
        position={Position.Bottom}
        className={classes.handle}
        style={{ bottom: -6 }}
      />
      <Box className={classes.nodeHeader}>
        <PlayArrow className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>
          {data?.label || "Inicio"}
        </Typography>
      </Box>
      {data?.description && (
        <Typography className={classes.nodeDescription}>
          {data.description}
        </Typography>
      )}
    </Box>
  );
};

export default StartNode;
